import { CSSObject } from '@chakra-ui/react';

export const FormsHStack: CSSObject = {
  px: '2',
  pb: '0',
  'input[name*="flexi"]': {
    ml: '0',
  },
};

export const ReviewContainer: CSSObject = {
  px: '1',
  borderRadius: 'base',
  bg: 'blackAlpha.400',
  boxShadow: 'inset 0px 1px 4px rgba(0, 0, 0, 0.3)',
  textTransform: 'uppercase',
  mb: '1',
};

export const EachWayText: CSSObject = {
  color: 'white',
  fontWeight: 'medium',
};

export const BoxReviewStakeContainer: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: 'blackAlpha.300',
};

export const ReviewStakeText: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
  color: 'white',
};

export const ReviewStake: CSSObject = {
  fontSize: 'md',
  color: 'beta.500',
  fontWeight: 'black',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
};

export const ReviewEstText: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
  color: 'white',
};

export const ReviewEst: CSSObject = {
  fontSize: '2xl',
  color: 'beta.500',
  fontWeight: 'black',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
};

export const ThemedInputAddon = (isPrefix: boolean): CSSObject => ({
  fontWeight: 'black',
  fontSize: 'sm',
  color: 'delta.500',
  bg: 'beta.500',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
  border: 'none',
  mt: '1',
  _groupFocusWithin: {
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.40)',
  },
  borderLeftRadius: isPrefix ? 'md' : 'none',
  borderRightRadius: isPrefix ? 'none' : 'md',
});

export const InputBetSlip: CSSObject = {
  border: '2px solid',
  color: 'white',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
  _placeholder: {
    textShadow: 'none',
    color: 'white',
    opacity: 0.5,
  },
  fontSize: 'sm',
  fontWeight: 'bold',
  ml: '2',
  '&&': {
    borderRightRadius: 'md',
    borderLeft: '2px solid',
    borderColor: 'beta.500',
    borderLeftRadius: 'md',
    bg: 'delta.500',
  },
};

export const FlexiReview: CSSObject = {
  pl: '1',
};

export const TreasureChestIcon: CSSObject = {
  color: 'beta.500',
};
